import { Space } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Space).attrs({
  direction: 'vertical',
})`
  width: 100%;
`;
